var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMiniMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0005 11.7969C5.8135 11.7971 5.63368 11.725 5.49853 11.5958V11.5951C2.31963 8.52424 1.31805 6.98435 1.31805 5.19321C1.31805 3.1102 2.62321 1.27775 4.62637 0.706404C7.79976 -0.197428 10.682 2.16162 10.682 5.19321C10.682 6.98298 9.68108 8.52355 6.50218 11.5951C6.36722 11.7245 6.18749 11.7968 6.0005 11.7969ZM5.99895 6.9132C6.91137 6.9132 7.65104 6.17354 7.65104 5.26111C7.65104 4.34869 6.91137 3.60902 5.99895 3.60902C5.08652 3.60902 4.34686 4.34869 4.34686 5.26111C4.34686 6.17354 5.08652 6.9132 5.99895 6.9132Z",
    fill: "#B2B8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMiniMarker);
export default __webpack_public_path__ + "static/media/ic_mini_marker.487b0bbf8e742e0e6895e493c5efb033.svg";
export { ForwardRef as ReactComponent };